import { Injectable } from '@angular/core';
import { CommonService } from '@core/services/common/common.service';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Country } from '@shipmercury/mercury-ui';
import { catchError, exhaustMap, forkJoin, map, of } from 'rxjs';
import {
  LoadCountriesProperties,
  LoadCountriesProps,
} from './countries.actions';

@Injectable()
export class CountriesEffects {
  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private commonService: CommonService
  ) {}

  loadCountriesProps$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(LoadCountriesProps),
        exhaustMap(() => {
          // Combine all the observables
          return forkJoin({
            countries: this.commonService
              .getCountries()
              .pipe(catchError(() => of(null))),
          }).pipe(
            map((res) => {
              const countries: Country[] = Array.isArray(res.countries.data)
                ? res.countries.data
                : [];
              this.store.dispatch(
                LoadCountriesProperties({
                  countryList: countries,
                })
              );
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
